export const MAINTENANCE_POLLING_EVENT = 'naxos:maintenance';

/**
 * Notify listeners that application polling should pause or resume.
 *
 * @param {boolean} active True while the CMS is in maintenance (overlay shown).
 */
export function setMaintenancePollingActive(active) {
	if (window.__naxosMaintenancePollingActive === active) {
		return;
	}

	window.__naxosMaintenancePollingActive = active;

	window.dispatchEvent(
		new CustomEvent(MAINTENANCE_POLLING_EVENT, {
			detail: { active },
			bubbles: false,
		}),
	);
}

/**
 * @returns {boolean}
 */
export function isMaintenancePollingPaused() {
	return window.__naxosMaintenancePollingActive === true;
}

/**
 * @param {unknown} response
 * @returns {boolean}
 */
export function isMaintenanceJsonResponse(response) {
	if (!response || typeof response !== 'object') {
		return false;
	}

	if (response.status === 'error' && typeof response.message === 'string') {
		return true;
	}

	return response.meta?.maintenance?.active === true;
}

/**
 * @param {{ pause?: () => void, resume?: () => void }} handlers
 * @returns {() => void}
 */
export function subscribeMaintenancePolling(handlers) {
	const listener = (event) => {
		if (event.detail?.active) {
			handlers.pause?.();
		} else {
			handlers.resume?.();
		}
	};

	window.addEventListener(MAINTENANCE_POLLING_EVENT, listener);

	return () => window.removeEventListener(MAINTENANCE_POLLING_EVENT, listener);
}
